const useBodyScrollLock = () => {
  const lockScroll = () => (document.body.style.overflowY = "hidden");
  const openScroll = () => (document.body.style.overflowY = "unset");

  return { lockScroll, openScroll };
};

export default useBodyScrollLock;
